import { ButtonProps } from '@design-system/button';
import { CarouselProps } from '@design-system/carousel';
import { CtaBlockProps } from '@design-system/cta-block';
import { FluidGridProps } from '@design-system/fluid-grid';
import { PageBlockProps } from '@design-system/page-block';
import { PaginationLabelsProps } from '@design-system/pagination';
import { WhereToBuyProps } from '@design-system/where-to-buy';
import { ReactElement, ReactNode } from 'react';

import {
  Filter,
  FilterMapperResult,
  ItemListingTypes,
  ItemTypes,
} from '~/mappers/itemListing/models';
import { TypographyUI } from '~/mappers/typography/models';

export interface ItemListingProps {
  fluidGrid: FluidGridProps;
  pageBlock: PageBlockProps;
  pagination?: PaginationLabelsProps;
  loadMoreButton?: ButtonProps;
  initialNumberArticles?: number;
  items: ReactNode[];
  rawItems: ItemListingTypes;
  type: string;
  id?: string;
  filterSettings?: FilterMapperResult;
  currentPageUid: string;
  uid: string;
  whereToBuyData: WhereToBuyProps;
  itemsName: string;
  itemsAmount: number;
  data: ItemTypes[];
  filters: Filter[];
  text: string;
  typographyUI: TypographyUI;
}

export interface ItemListingCarouselProps {
  pageBlock: PageBlockProps;
  items: ReactElement[];
  carousel: CarouselProps;
  id?: string;
  showMore?: CtaBlockProps;
  uid: string;
}

export enum FilterOption {
  SideFilters = 'side-filters',
  TopFilters = 'top-filters',
}
